import { useRouteLoaderData } from '@remix-run/react';
import { useMemo } from 'react';

import type { loader as rootLoader } from '~/root';
import { defaultLocale } from '~/utils/language';
import { createRoutePath } from '~/utils/routePath';

export function useRoutePath() {
  const data = useRouteLoaderData<typeof rootLoader>('root');
  const locale = data?.locale ?? defaultLocale;
  const channelDefaultLocale = data?.channelConfig?.defaultLocale;

  // Memoize so the returned builder keeps a stable identity across renders.
  // createRoutePath() returns a fresh closure each call; without this, any effect
  // that lists routePath in its deps re-runs every render (see AccountLayout redirect).
  return useMemo(() => createRoutePath(locale, channelDefaultLocale), [locale, channelDefaultLocale]);
}
